<template>
  <div class="war-room-post-content">
    <WarRoomPostContentYoutube v-if="isYoutube" :content="content.data" class="war-room-post-content__youtube" />
    <WarRoomPostContentStory v-if="content.data.text" :text="fixedContent" />
    <WarRoomPostContentLink v-if="isLink" :content="content.data" class="war-room-post-content__link" />
    <WarRoomPostContentLinkedin v-if="isLinkedin" :content="content.data" class="war-room-post-content__linkedin" />
  </div>
</template>

<script>
import 'lazysizes';
import { postTypes } from '../constants';
import WarRoomPostContentStory from '@/components/partials/war-room/WarRoomPostContent/WarRoomPostContentStory.vue';
import WarRoomPostContentLink from '@/components/partials/war-room/WarRoomPostContent/WarRoomPostContentLink.vue';
import WarRoomPostContentYoutube from '@/components/partials/war-room/WarRoomPostContent/WarRoomPostContentYoutube.vue';
import WarRoomPostContentLinkedin from '@/components/partials/war-room/WarRoomPostContent/WarRoomPostContentLinkedin.vue';
import { fixLinkWhitespace } from '~/components/partials/war-room/utils';

export default {
  name: 'WarRoomPostContent',
  components: {
    WarRoomPostContentStory,
    WarRoomPostContentLink,
    WarRoomPostContentYoutube,
    WarRoomPostContentLinkedin,
  },
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isLink() {
      return this.content.type === postTypes.LINK;
    },
    isYoutube() {
      return this.content.type === postTypes.YOUTUBE;
    },
    isLinkedin() {
      return this.content.type === postTypes.LINKEDIN;
    },
    // Backward compatibility for old bug with whitespace in links
    fixedContent() {
      return fixLinkWhitespace(this.content.data.text);
    },
  },
};
</script>

<style scoped lang="scss">
.war-room-post-content {
  &__link,
  &__linkedin {
    margin: 20px 0;
  }

  &__youtube {
    margin-bottom: 20px;
  }

  ::v-deep img {
    max-width: 100%;
  }
}
</style>
